import { FC } from "react";
import { GradientButton, PhoneFrame } from "./components";
import { useLocation, useNavigate } from "react-router-dom";

import AddingSecureSVG from "../../assets/AddingSecureSVG.svg";

import "./styles.css";

export const AddingSecure: FC = () => {
	const location = useLocation();

	const { accountType } = location.state;

	const navigate = useNavigate();

	return (
		<div className="w-full h-screen flex justify-center items-center gap-20 background">
			<PhoneFrame
				onPress={() =>
					navigate("/create-account-wallet/create-password", {
						state: { accountType },
					})
				}
			/>

			<div className="bg-[#7C7775]/80 max-w-[60%] rounded-2xl p-[4%] border-2 border-black">
				<div className="w-full items-center justify-center flex flex-col">
					<img src={AddingSecureSVG} alt="" />
					<p className="text-white text-2xl font-light text-center mb-8 mt-10 max-2xl:text-base max-2xl:mt-5 max-2xl:mb-2">
						Agora vamos adicionar <br />
						<strong className="font-bold text-white ">mais segurança</strong> a{" "}
						<br />
						sua conta.
					</p>

					<h3 className="text-white text-2xl font-light text-center mb-10 max-2xl:mb-5 max-2xl:text-lg">
						Tudo <strong className="font-bold text-white">certo</strong> por
						aqui!
					</h3>

					<GradientButton
						tailwindStyles=" bg-[#AA7339] w-[12rem] xl:w-[24rem] h-12 lg:h-16 text-white p-texte"
						title="Começar"
						onClick={() =>
							navigate("/create-account-wallet/identification", {
								state: { accountType },
							})
						}
					/>
				</div>
			</div>
		</div>
	);
};
